// API endpoint for backend
const API_URL = process.env.REACT_APP_BACKEND_URL;

export const submitContactForm = async (formData) => {
  try {
    // Send email via backend
    const emailResponse = await fetch(`${API_URL}/api/contact/send-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message
      })
    });

    const emailResult = await emailResponse.json();

    // Store submission in localStorage for records
    const submissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
    const newSubmission = {
      ...formData,
      id: Date.now(),
      timestamp: new Date().toISOString(),
      emailSent: emailResult.success
    };
    submissions.push(newSubmission);
    localStorage.setItem('contactSubmissions', JSON.stringify(submissions));

    console.log('Form submitted:', newSubmission);
    console.log('Email result:', emailResult);

    // Return success if email was sent successfully
    return {
      success: emailResult.success,
      message: emailResult.message || 'Form submitted successfully',
      data: newSubmission
    };
  } catch (error) {
    console.error('Error submitting form:', error);

    // Fallback: store locally even if email fails
    const submissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
    const newSubmission = {
      ...formData,
      id: Date.now(),
      timestamp: new Date().toISOString(),
      emailSent: false,
      error: error.message
    };
    submissions.push(newSubmission);
    localStorage.setItem('contactSubmissions', JSON.stringify(submissions));

    return {
      success: false,
      message: 'Form saved locally, but email sending failed: ' + error.message,
      data: newSubmission
    };
  }
};

export const getContactSubmissions = () => {
  return JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
};